export default __webpack_public_path__ + "static/media/google-drive-logo.f2157d10.png";